import { deepEqual } from '@makeswift/controls'

export default deepEqual
